// @flow

import React, { PureComponent } from 'react';
import cx from 'classnames';
import 'client/styles/check.scss';

type Props = {
  checked: boolean,
  style?: Object,
  className?: string,
  clickHandler: Function,
  size?: string,
};

class Questionmark extends PureComponent<Props> {
  static defaultProps = {
    style: {},
    className: '',
    size: '2.5rem',
  };

  render() {
    const { checked, style, className, clickHandler, size, ...others } = this.props;
    return (
      <button
        {...others}
        aria-label="more-info"
        className={cx(className, { checked }, 'questionmark-toggle')}
        onClick={(e) => {
          e.preventDefault();
          clickHandler(e);
        }}
        style={{
          ...style,
          fontSize: size,
        }}>
        <div className="questionmark-checked checked-bg-container">
          <div className="checked-bg" />
        </div>
        <div className="icon-info blue-color questionmark no-margin" />
      </button>
    );
  }
}

export default Questionmark;
